<template>
    <div class="card_body">
        <div class="card_content">
            <van-row class="fieldRow">
                <van-col class="field_row" span="16">{{ props.title1 }}</van-col>
                <van-col class="field_row_value" span="8">
                    <span>{{ props.value1 }}</span>
                    <div v-if="props.rightText2">{{ props.rightText2 }}</div>
                </van-col>
            </van-row>
            <van-row>
                <van-col class="field_row" span="16">{{ props.title2 }}</van-col>
                <van-col class="field_row_value" span="8">
                    <span>{{ props.value2 }}</span>
                    <div v-if="props.rightText2">{{ props.rightText2 }}</div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    title1: {
        type: String,
        default: () => ''
    },
    title2: {
        type: String,
        default: () => ''
    },
    title3: {
        type: String,
        default: () => ''
    },
    value1: {
        type: [String, Number],
        default: () => 0
    },
    value2: {
        type: [String, Number],
        default: () => 0
    },
    value3: {
        type: [String, Number],
        default: () => 0
    },
    rightText1: {
        type: String,
        default: () => ''
    },
    rightText2: {
        type: String,
        default: () => ''
    },
})

</script>
<style scoped>
.card_body {
    overflow: hidden;
    font-size: 15px;
    position: relative;
    margin: 5px 0;
}

.card_body img {
    width: 100%;
}

.card_body img {
    width: 100%;
}

.card_content {
    background: #101629;
    margin: 2.5px;
    overflow: hidden;
    border-radius: 10px;
    padding: 0 15px;
}

.field_row {
    padding: 18px 15px;
    color: #9BA7BE;
}

.total_row {
    padding: 18px 15px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: bold;
}

.field_row_value {
    padding: 18px 15px;
    color: #fff;
    display: flex;
    font-size: 13px;
    justify-content: right;
    align-items: center;
}

.field_row_value span {
    padding: 0 5px;
    color: #FBA531;
    font-size: 16px;
}
.fieldRow{
    border-bottom: #ffffff1f 1px solid;
}
.totalRow{
    background: #ffffff38;
    
}
</style>